import React, { Fragment, FC, ChangeEvent, useState, useEffect } from 'react';
import { formatDate } from 'utils/format';
import { TableCell, IconButton, Tooltip, Chip, TextField } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { MaterialBatch } from 'models/material';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';

type MaterialBatchItemProps = {
    batch: MaterialBatch;
    index: number;
    onQuantityChange: (quantity: number, batch: MaterialBatch, index: number) => void;
    onMoveUpBatch: (batch: MaterialBatch, index: number) => void;
    onMoveDownBatch: (batch: MaterialBatch, index: number) => void;
    onCloseBatch: (batch: MaterialBatch, index: number) => void;
};
const MaterialBatchItem: FC<MaterialBatchItemProps> = ({
    index,
    batch,
    onQuantityChange,
    onMoveUpBatch,
    onMoveDownBatch,
    onCloseBatch: onCloseBatch,
}: MaterialBatchItemProps) => {
    const { t: translate } = useTranslation(['common', 'lab-settings']);
    const [quantity, setQuantity] = useState(batch.quantity);

    useEffect(() => {
        setQuantity(batch.quantity);
    }, [batch, onMoveUpBatch, onMoveDownBatch, onMoveDownBatch]);

    const handleQuantityChange = (event: ChangeEvent<HTMLInputElement>) => {
        const quantity = event.target.value;
        if (quantity === '') {
            setQuantity(0);
            onQuantityChange(0, batch, index);
            return;
        }
        setQuantity(parseFloat(quantity));
        onQuantityChange(parseFloat(quantity), batch, index);
    };

    return (
        <Fragment>
            <TableCell>{batch.batchNumber}</TableCell>
            <TableCell>{batch.fullBatchQuantity}</TableCell>
            <TableCell sx={{ width: '130px' }}>{formatDate(batch.createdOn, 'date')}</TableCell>
            {!batch.closed ? (
                <TableCell sx={{ width: '130px' }} align="right">
                    <Fragment>
                        <IconButton size="small" onClick={() => onMoveUpBatch(batch, index)}>
                            <ArrowUpwardIcon fontSize="inherit" />
                        </IconButton>
                        <IconButton size="small" onClick={() => onMoveDownBatch(batch, index)}>
                            <ArrowDownwardIcon fontSize="inherit" />
                        </IconButton>
                        <Tooltip title={translate('lab-settings:CLOSE_BATCH').toString()} placement="right">
                            <IconButton size="small" onClick={() => onCloseBatch(batch, index)}>
                                <HighlightOffIcon color="error" fontSize="inherit" />
                            </IconButton>
                        </Tooltip>
                    </Fragment>
                </TableCell>
            ) : (
                <Fragment>
                    <TableCell>{formatDate(new Date(batch.closedDate ? batch.closedDate : ''), 'date')}</TableCell>
                    <TableCell>
                        <Chip label={translate('lab-settings:CLOSED')} size="small" color="error" />
                    </TableCell>
                </Fragment>
            )}
        </Fragment>
    );
};

export default MaterialBatchItem;
